export default "__VITE_ASSET__DuA0JkH0__"